import type { LanguageDetectionResult } from '~/models/LangaugeDetector'
import { comprehendClient } from '~/api/client/comprehendClient'
import { sha1 } from '~/utils/crypto'

export function useComprehendApi() {
  const batchDetectLanguage = async (text: string[]): Promise<LanguageDetectionResult> => {
    const cacheKey = await sha1(text.join(','))
    return comprehendClient.post(`/detect/${cacheKey}`, text)
      .then(response => response.data)
  }

  return {
    batchDetectLanguage,
  }
}
